import React from 'react';
import { useTranslation } from 'react-i18next';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Footer } from '@components/molecules/Footer';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { ContactsSection } from '@components/molecules/ContactsSection/ContactsSection';
import { MenuPages } from '@types';
import { useData } from '@hooks/useData';

export function Contacts() {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('contacts-component.title'),
    };

    return (
        <>
            <StickyHeader menuActivePage={MenuPages.Contacts} />

            <BreadcrumbsBanner
                title={translations.title}
                links={[]}
                currentPage={translations.title}
                image={allSettings?.data?.content_headers_contacts_image?.src}
            />

            <ContactsSection />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </>
    );
}
